import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';

const categoryHeroUrls: Record<string, string> = {
  love: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20artistic%20illustration%2C%20soft%20pink%20warm%20tones%2C%20romantic%20atmosphere%2C%20elegant%20digital%20art%2C%20beautiful%20couple%20silhouette%2C%20dreamy%20gentle%20lighting&width=1600&height=900&seq=cat-hero-love&orientation=landscape',
  action: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20artistic%20illustration%2C%20dynamic%20battle%20scene%2C%20dramatic%20lighting%2C%20intense%20energy%2C%20fighter%20silhouette%2C%20dark%20atmospheric%20mood%2C%20powerful%20composition&width=1600&height=900&seq=cat-hero-action&orientation=landscape',
  fantasy: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20artistic%20illustration%2C%20magical%20world%2C%20mysterious%20atmosphere%2C%20epic%20landscape%2C%20glowing%20magic%20elements%2C%20dreamy%20composition%2C%20cinematic%20fantasy%20art&width=1600&height=900&seq=cat-hero-fantasy&orientation=landscape',
  horror: 'https://readdy.ai/api/search-image?query=Korean%20horror%20manhwa%20artistic%20illustration%2C%20dark%20ominous%20atmosphere%2C%20mysterious%20shadows%2C%20tense%20mood%2C%20thriller%20vibe%2C%20dark%20corridor%2C%20suspenseful%20composition&width=1600&height=900&seq=cat-hero-horror&orientation=landscape',
  comedy: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20artistic%20illustration%2C%20bright%20colorful%20style%2C%20funny%20playful%20atmosphere%2C%20humorous%20scene%2C%20warm%20lighting%2C%20happy%20vibe%2C%20cheerful%20composition&width=1600&height=900&seq=cat-hero-comedy&orientation=landscape',
  drama: 'https://readdy.ai/api/search-image?query=Korean%20urban%20drama%20manhwa%20artistic%20illustration%2C%20modern%20cityscape%2C%20professional%20atmosphere%2C%20sophisticated%20style%2C%20warm%20evening%20lighting%2C%20realistic%20composition&width=1600&height=900&seq=cat-hero-drama&orientation=landscape',
  school: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20artistic%20illustration%2C%20cherry%20blossom%20campus%2C%20youthful%20atmosphere%2C%20warm%20spring%20lighting%2C%20friendship%20theme%2C%20nostalgic%20feel%2C%20bright%20composition&width=1600&height=900&seq=cat-hero-school&orientation=landscape',
  historical: 'https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20artistic%20illustration%2C%20ancient%20palace%2C%20traditional%20Korean%20aesthetic%2C%20golden%20warm%20lighting%2C%20elegant%20classical%20style%2C%20royal%20atmosphere%2C%20ornate%20composition&width=1600&height=900&seq=cat-hero-historical&orientation=landscape',
};

const coverUrls: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20dark%20fantasy%20hunter%20with%20blue%20energy%20aura%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%2C%20Korean%20digital%20illustration%2C%20manga%20style%20art%2C%20clean%20composition%2C%20vibrant%20contrast%2C%20professional%20manhwa%20cover&width=600&height=800&seq=cover-solo-leveling&orientation=portrait',
  2: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20young%20woman%20with%20makeup%2C%20soft%20pastel%20aesthetic%2C%20shojo%20manga%20style%2C%20Korean%20digital%20illustration%2C%20romantic%20atmosphere%2C%20clean%20composition%2C%20professional%20cover%20art&width=600&height=800&seq=cover-true-beauty&orientation=portrait',
  3: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20apocalyptic%20scene%20with%20protagonist%20holding%20a%20book%2C%20dramatic%20dark%20atmosphere%2C%20mysterious%20constellations%2C%20Korean%20digital%20art%2C%20action%20fantasy%20style%2C%20professional%20manhwa%20cover&width=600&height=800&seq=cover-omniscient&orientation=portrait',
  4: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20manhwa%20cover%2C%20elegant%20queen%20in%20lavish%20royal%20gown%2C%20palace%20background%2C%20golden%20accents%2C%20romance%20drama%20style%2C%20Korean%20digital%20illustration%2C%20ornate%20composition%2C%20professional%20cover&width=600&height=800&seq=cover-remarried-empress&orientation=portrait',
  5: 'https://readdy.ai/api/search-image?query=Korean%20action%20drama%20manhwa%20cover%2C%20dual%20identity%20concept%20with%20two%20contrasting%20male%20figures%2C%20urban%20school%20setting%2C%20dramatic%20lighting%2C%20Korean%20digital%20art%2C%20realistic%20style%2C%20professional%20cover&width=600&height=800&seq=cover-lookism&orientation=portrait',
  6: 'https://readdy.ai/api/search-image?query=Korean%20horror%20thriller%20manhwa%20cover%2C%20dark%20apartment%20building%2C%20monstrous%20silhouette%2C%20tense%20atmosphere%2C%20survival%20horror%20theme%2C%20Korean%20digital%20illustration%2C%20dramatic%20lighting%2C%20professional%20cover&width=600&height=800&seq=cover-sweet-home&orientation=portrait',
  7: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%2C%20young%20princess%20in%20elegant%20dress%2C%20royal%20palace%20setting%2C%20soft%20warm%20lighting%2C%20father%20daughter%20theme%2C%20Korean%20digital%20art%2C%20beautiful%20composition&width=600&height=800&seq=cover-wmmap&orientation=portrait',
  8: 'https://readdy.ai/api/search-image?query=Korean%20action%20martial%20arts%20manhwa%20cover%2C%20fierce%20warrior%20in%20dynamic%20fighting%20pose%2C%20intense%20battle%20scene%2C%20dramatic%20lighting%2C%20Korean%20digital%20illustration%2C%20powerful%20composition&width=600&height=800&seq=cover-crazy-king&orientation=portrait',
  9: 'https://readdy.ai/api/search-image?query=Korean%20urban%20drama%20manhwa%20cover%2C%20confident%20businessman%20in%20suit%2C%20city%20skyline%20background%2C%20modern%20aesthetic%2C%20Korean%20digital%20art%2C%20professional%20cover%2C%20clean%20stylish%20look&width=600&height=800&seq=cover-son-in-law&orientation=portrait',
  10: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20cover%2C%20four%20teenage%20girls%20together%2C%20school%20uniform%2C%20cherry%20blossom%20background%2C%20friendship%20theme%2C%20Korean%20digital%20illustration%2C%20warm%20spring%20atmosphere&width=600&height=800&seq=cover-girls-world&orientation=portrait',
  11: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20funny%20expression%20of%20tough%20man%20with%20cute%20smart%20baby%2C%20humorous%20concept%2C%20bright%20colorful%20style%2C%20Korean%20digital%20illustration%2C%20playful%20composition&width=600&height=800&seq=cover-genius-baby&orientation=portrait',
  12: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20adventure%20manhwa%20cover%2C%20mysterious%20tower%20rising%20to%20sky%2C%20young%20hero%20with%20determination%2C%20epic%20scale%2C%20fantasy%20world%2C%20Korean%20digital%20illustration%2C%20cinematic%20composition%2C%20professional%20cover&width=600&height=800&seq=cover-tower-of-god&orientation=portrait',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryComics = comics.filter((c) => c.category === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-20 px-6 text-center py-32">
          <h1 className="text-2xl font-bold">分类不存在</h1>
          <Link to="/" className="text-primary-500 mt-4 inline-block">返回首页</Link>
        </div>
        <Footer />
      </>
    );
  }

  const heroImg = categoryHeroUrls[slug] || categoryHeroUrls.action;

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 炮渣漫画网`,
    description: category.description,
    url: `http://pepmayans.com/category/${slug}`,
    isPartOf: { '@type': 'WebSite', name: '炮渣漫画网', url: 'http://pepmayans.com/' },
  };

  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
          <img
            src={heroImg}
            alt={`${category.name} - 炮渣漫画网`}
            title={`${category.name} - 韩国漫画分类`}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/55"></div>

          <div className="relative z-10 w-full h-full flex flex-col justify-center px-6 md:px-10">
            <div className="pt-20">
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
                {category.name}
              </h1>
              <p className="text-white/80 text-sm md:text-base max-w-[480px]">
                {category.description}
              </p>
            </div>
          </div>
        </section>

        <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
          <Breadcrumb items={[
            { label: '首页', to: '/' },
            { label: category.name },
          ]} />
        </div>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
            <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10">
              <div>
                <h2 className="font-label text-sm font-semibold text-foreground-400 uppercase tracking-wider mb-2">
                  {category.name}
                </h2>
                <h3 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 italic">
                  全部作品
                </h3>
              </div>
              <p className="text-sm text-foreground-600 max-w-[400px]">
                共 {categoryComics.length} 部漫画作品
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {categoryComics.map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/article/${comic.id}`}
                  className={`group block rounded-2xl overflow-hidden transition-all duration-300 ${
                    index === 2 ? 'bg-primary-800' : 'bg-background-100'
                  }`}
                >
                  <div className="relative aspect-[3/4] overflow-hidden rounded-t-2xl">
                    <img
                      src={coverUrls[comic.id] || coverUrls[1]}
                      alt={comic.title}
                      title={`${comic.title} - 韩国漫画`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="bg-secondary-500 text-foreground-950 text-xs font-bold px-2.5 py-1 rounded-full">
                        {category.name}
                      </span>
                    </div>
                  </div>
                  <div className={`p-5 ${index === 2 ? 'text-white' : ''}`}>
                    <h3 className={`font-heading text-lg font-bold mb-2 line-clamp-2 ${index === 2 ? 'text-white' : 'text-foreground-900'}`}>
                      {comic.title}
                    </h3>
                    <p className={`text-xs mb-3 ${index === 2 ? 'text-white/60' : 'text-foreground-500'}`}>
                      {comic.author} · {comic.status}
                    </p>
                  </div>
                </Link>
              ))}
            </div>

            {categoryComics.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无漫画</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
    </>
  );
}